import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { SxProps, Theme } from "@mui/material";

interface ExpandIconProps {
  isExpanded: boolean;
  sx?: SxProps<Theme>;
}

const ExpandIcon = ({ isExpanded, sx }: ExpandIconProps) =>
  isExpanded
    ? <ExpandLessIcon sx={sx} />
    : <ExpandMoreIcon sx={sx} />;

export default ExpandIcon;
